import styled from 'styled-components'
import { Link } from 'gatsby'

import { themeStyles, themeMedia } from '../../../styles/theme'

export const StyledPromotionsOuterWrapper = styled.div`
  display: flex;
  flex-direction: column;

  button {
    margin: 1em auto;
  }
`

export const StyledGrid = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 26px;
  padding: 0 0 1rem;

  ${themeMedia.tablet`
    padding: 2rem 0 1rem;
    display: grid;
    grid-template-columns: repeat(auto-fill,minmax(calc(50% - 20px), 1fr));
  `};

  ${themeMedia.widescreen`
    grid-template-columns: repeat(auto-fill,minmax(calc(33.33333% - 20px), 1fr));
  `};
`

export const StyledPromo = styled(Link)`
  text-decoration: none;
  border: 2px solid ${themeStyles.colors.white.main}00;
  transition: 0.2s;
  border-radius: 10px;

  &:hover {
    border: 2px solid ${themeStyles.colors.white.main}4C;
    text-decoration: none;
  }
`

export const StyledPromoImgWrapper = styled.div`
  margin: 0 0 -0.2rem;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  position: relative;
  overflow: hidden;
  padding-top: 52.5%;

  img {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`

export const StyledPromoDetails = styled.div`
  background-color: ${themeStyles.colors.darkGreys[4].main};
  color: ${themeStyles.colors.white.main};
  min-height: 116px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  position: relative;
  padding: 1rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`

export const StyledBottomRow = styled.div`
  display: flex;
  width: 100%;
  gap: 0.5em;
`

export const StyledEndDate = styled.div`
  display: flex;
  gap: 0.4em;
  margin-left: auto;

  > * {
    margin: 0;
  }
`
